<template>
  <div class="animated revealUp">
    <div class="section-title mb-4">
      {{ $t("transaction") }} {{ $tc("refund", 1) }} {{ $t("Report") }}
    </div>
    <div class="white-wrapper">
      <div class="row">
        <!-- SELECT DROPDOWN -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container mr-2">
            <label :class="getTransactionRefundSelectedCinema ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :text="getTransactionRefundSelectedCinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  :placeholder="$tc('searchCinema')"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema()"
                  v-on:keydown="onSearchCinema()"
                  v-on:search="onSearchCinema()"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(dropdownItem, dropdownIndex) in Cinemas"
                :key="dropdownIndex"
                @click="
                  onTransactionRefundsDropDownHandler({
                    event: $event,
                    name: 'isCinema',
                    selectedItem: dropdownItem,
                    index: dropdownIndex
                  });
                  searchCinema = '';
                  onSearchCinema();
                  onSelectCinema(dropdownItem);
                "
                >{{ dropdownItem.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="getTransactionRefundFromDate"
                @click="clearDate({ name: 'fromDate' })"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                @selected="
                  onTransactionRefundsDropDownHandler({
                    event: $event,
                    name: 'fromDate',
                  })
                "
                :value="getTransactionRefundFromDate"
                :typeable="true"
              ></Datepicker>
              <label :class="getTransactionRefundFromDate ? 'active' : ''">{{
                $t("startdate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="getTransactionRefundEndDate"
                @click="clearDate({ name: 'endDate' })"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                @selected="
                  onTransactionRefundsDropDownHandler({
                    event: $event,
                    name: 'endDate',
                  })
                "
                :value="getTransactionRefundEndDate"
                :typeable="true"
              ></Datepicker>
              <label :class="getTransactionRefundEndDate ? 'active' : ''">{{
                $t("enddate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                :value="getTransactionRefundFilterValue"
                name="filterValue"
                id="filterValue"
                @input="changeFilterValues($event)"
              />
              <label>{{ $tc("showBookingCode") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <button
            :disabled="enablebutton"
            @click="ButtonValue(true)"
            class="btn-blue-lg w-100"
          >
            {{ $tc("submit") }}
          </button>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 d-flex justify-content-end mb-2 align-items-center"
          v-if="getTransactionRefundstData.length > 0"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
          <a href="#" @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>

          <a target="_blank" @click="generateReport()" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
        </div>
      </div>
      <!---Pdf Export-->
      <div class="d-none">
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :paginate-elements-by-height="1400"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a2"
          pdf-orientation="landscape"
          pdf-content-width="100%"
          ref="html2Pdf"
          @beforeDownload="beforeDownload($event)"
        >
          <div slot="pdf-content">
            <div
              class="d-flex justify-content-center mb-3 font-weight-bold fs-16 pdf_heading_alignment"
            >
              Transaction Refund Report
            </div>

            <div class="pdf_heading_alignment">
              <div class="d-flex mb-3 flex-wrap justify-content-between ml-2 ">
                <span class="mb-4">
                  <span class="font-weight-bold">Cinema Name:</span>
                  {{ getTransactionRefundSelectedCinema }}</span
                >
                <div class="ml-5">
                  <span
                    ><span class="font-weight-bold">From Date:</span>
                    {{ getTransactionRefundFromDate | dateparse }}</span
                  >
                  <span class="ml-2"
                    ><span class="font-weight-bold">To Date:</span>
                    {{ getTransactionRefundEndDate | dateparse }}</span
                  >
                </div>
                <div class="d-flex">
                  <span class="font-weight-bold">Generated At:</span>
                  <span class="ml-1">{{ moment().format("llll") }}</span>
                </div>
              </div>
            </div>

            <table
              class="swc-report-table "
              border="1"
              style="width:90%;margin:auto"
            >
              <thead>
                <tr class="bg-lightgrey">
                  <th colspan="2">
                    {{ $t("transaction") }} {{ $t("number") }}
                  </th>
                  <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th>
                  <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
                  <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
                  <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
                  <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
                  <th>Sales Channel</th>
                  <th>
                    <p class="mb-0">
                      {{ $tc("seat", 1) }} {{ $tc("number", 1) }}
                    </p>
                  </th>
                  <th>{{ $tc("refund", 1) }} Date & Time</th>
                  <th>Minutes After Session Started</th>
                  <th>{{ $tc("refund", 1) }} {{ $t("amount") }}</th>
                  <th>{{ $tc("refund", 1) }} {{ $tc("reason", 1) }}</th>
                  <th>{{ $t("refunded_by") }}</th>
                  <th>{{ $tc("payment", 1) }} {{ $tc("mode", 1) }}</th>
                  <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                  <th>{{ $t("mobileNo") }}</th>
                </tr>
              </thead>

              <tbody
                v-if="getTransactionRefundstData.length > 0"
                class="sph-report"
                :style="cssVars"
              >
                <tr
                  v-for="(transaction,
                  transactionIndex) in getTransactionRefundstData"
                  :key="transactionIndex"
                >
                  <td colspan="2" :class="transaction.isSwap > 0 ? 'swap' : ''">
                    {{ transaction.sb_booking_code }}
                  </td>
                  <td>{{ transaction.t_booking_date_time | fulldateparse }}</td>
                  <td class="text-left">{{ transaction.film_name }}</td>
                  <td>{{ transaction.t_show_date | dateparse }}</td>
                  <td class="text-right">{{ transaction.t_show_time }}</td>
                  <td class="text-left">{{ transaction.screen_name }}</td>
                  <td class="text-left">{{ transaction.booking_source }}</td>
                  <td class="text-break">{{ transaction.seats }}</td>
                  <td class="text-right">
                    {{ transaction.total_refund_amount | RoundOff }}
                  </td>
                  <td class="text-right">
                    {{ transaction.t_refund_date_time || "" }}
                  </td>
                  <td class="text-left">
                    {{
                      transaction.time_difference > 0
                        ? transaction.time_difference
                        : "-"
                    }}
                  </td>
                  <td class="text-left">{{ transaction.rr_reason || "-" }}</td>
                  <td class="text-left">
                    {{ transaction.refunded_by || "-" }}
                  </td>
                  <td class="text-left">
                    {{ transaction.pm_payment_mode || "-" }}
                  </td>
                  <td class="text-left">
                    {{
                      transaction.customer_name || transaction.guest_name || "-"
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      transaction.customer_mobile ||
                        transaction.guest_mobile ||
                        "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vue-html2pdf>
      </div>

      <!---Pdf Export End-->

      <div class="swc-report" style="overflow-x: auto">
        <table
          class="swc-report-table"
          border="1"
          style="width: auto !important"
        >
          <thead>
            <tr class="bg-lightgrey">
              <th colspan="2">{{ $t("transaction") }} {{ $t("number") }}</th>
              <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th>
              <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
              <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
              <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
              <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
              <th>Sales Channel</th>
              <th>
                <p class="mb-0">{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</p>
              </th>
              <th>{{ $tc("refund", 1) }} {{ $t("amount") }}</th>
              <th>{{ $tc("refund", 1) }} Date & Time</th>
              <th>Minutes After Session Started</th>
              <th>{{ $tc("refund", 1) }} {{ $tc("reason", 1) }}</th>
              <th>{{ $t("refunded_by") }}</th>
              <th>{{ $t("authorizedBy") }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("mode", 1) }}</th>
              <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
              <th>{{ $t("mobileNo") }}</th>
            </tr>
          </thead>

          <tbody
            v-if="getTransactionRefundstData.length > 0"
            class="sph-report"
            :style="cssVars"
          >
            <tr
              v-for="(transaction,
              transactionIndex) in getTransactionRefundstData"
              :key="transactionIndex"
            >
              <td colspan="2" :class="transaction.isSwap > 0 ? 'swap' : ''">
                {{ transaction.sb_booking_code }}
              </td>
              <td>{{ transaction.t_booking_date_time | fulldateparse }}</td>
              <td class="text-left">{{ transaction.film_name }}</td>
              <td>{{ transaction.t_show_date | dateparse }}</td>
              <td class="text-right">{{ transaction.t_show_time }}</td>
              <td class="text-left">{{ transaction.screen_name }}</td>
              <td class="text-left">{{ transaction.booking_source }}</td>
              <td class="text-break">{{ transaction.seats }}</td>
              <td class="text-right">
                {{ transaction.total_refund_amount | RoundOff }}
              </td>
              <td class="text-left">
                {{ transaction.t_refund_date_time || "" }}
              </td>
              <td class="text-left">
                {{
                  transaction.time_difference > 0
                    ? transaction.time_difference
                    : "-"
                }}
              </td>
              <td class="text-left">{{ transaction.rr_reason || "-" }}</td>
              <td class="text-left">{{ transaction.refunded_by || "-" }}</td>
              <td class="text-left">{{transaction.refund_approved_by || "-"}}</td>
              <td class="text-left">
                {{ transaction.pm_payment_mode || "-" }}
              </td>
              <td class="text-left">
                {{ transaction.customer_name || transaction.guest_name || "-" }}
              </td>
              <td class="text-right">
                {{
                  transaction.customer_mobile || transaction.guest_mobile || "-"
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="14">
                <!-- <p class="h6 text-center">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import moment from "moment";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: { DatePicker, NoRecords, VueHtml2pdf },
  data() {
    return {
      htmlToPdfOptions: {
        filename: "Box Office Receipt Report",
        margin: 2,
        image: {
          type: "jpeg",
          quality: 2
        },
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape"
        }
      },
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      filterValue: "",
      filterKey: ""
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getTransactionRefundstData",
      "getTransactionRefundFromDate",
      "getTransactionRefundFilterValue",
      "getTransactionRefundEndDate",
      "getTransactionRefundSelectedCinema",
      "enablebutton",
      "isCinemaManager",
      "cinema_name",
      "swaptextcolor"
    ]),
    cssVars() {
      return {
        "--swap-color": this.swaptextcolor
      };
    }
  },
  watcher: {
    "this.$store.getters.cinema_name"(newval) {
      this.selectedCinema = { cine_name: newval };
    }
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.onTransactionRefundsDropDownHandler({
    //     event: null,
    //     name: "isCinema",
    //     selectedItem: CinemaObj
    //   });
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onTransactionRefundsDropDownHandler({
    //       event: null,
    //       name: "isCinema",
    //       selectedItem: CinemaObj
    //     });
    //   }
    // }
  },
  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
  },
  methods: {
    moment,
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Transaction Refund" + date.getTime();
      this.htmlToPdfOptions.filename = this.pdfFileName;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then(pdf => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(18);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },
    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onFetchTransactionRefunds",
      "ButtonValue",
      "onTransactionRefundsDropDownHandler",
      "clearDate"
    ]),
    excelDownload() {
      // let data = this.getTransactionRefundstData;
      let new_records = [];

      this.getTransactionRefundstData.map(x => {
        let obj = {
          ...x,
          cinema_name: this.getTransactionRefundSelectedCinema,
          from_date: this.getTransactionRefundFromDate,
          end_date: this.getTransactionRefundEndDate
        };
        new_records.push(obj);
      });
      console.log({ new_records });
      //   let temp_arr = this.getRateCardStandard,
      //   getRateCardredemptions :[],
      //   getRateCardcomplementories:[],;
      //   temp_arr = this.getBoxOfficeReport.map(x => {
      //     x.show_time_array.map(z => {
      //       let obj = {
      //         ...x,
      //         ...z
      //       };
      //       new_records.push(obj);
      //     });
      //   });
      //   console.log("new_records", new_records);
      let dateparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function(value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };
      let data = [
        {
          sheet: "Transaction Refund Report",
          columns: [
            {
              value: "cinema_name",
              label: "Cinema Name"
            },
            {
              value: "from_date",
              label: "Start Date"
            },
            {
              value: "end_date",
              label: "End Date"
            },
            {
              value: "sb_booking_code",
              label: "Transaction Number"
            },
            {
              value: "sb_booking_code",
              label: "Transaction Number"
            },
            {
              value: row => fulldatemonparse(row.t_booking_date_time),
              label: "Booking Date"
            },
            {
              value: "film_name",
              label: "Film Name"
            },
            {
              value: row => dateparse(row.t_show_date),
              label: "Show Date"
            },
            {
              value: "t_show_time",
              label: "Show Time"
            },
            {
              value: "screen_name",
              label: "Screen Name"
            },
            {
              value: "booking_source",
              label: "Sales Channel"
            },
            {
              value: "seats",
              label: "Seat Number"
            },
            {
              value: row => Math.round(row.total_refund_amount),
              label: "Refund Sales Price"
            },
            {
              value: row => (row.rr_reason ? row.rr_reason : "-"),
              label: "Refund Reason"
            },
            {
              value: row => (row.refunded_by ? row.refunded_by : "-"),
              label: "Refunded By"
            },
            {
              value: row => (row.pm_payment_mode ? row.pm_payment_mode : "-"),
              label: "Payment Mode"
            },
            {
              value: row =>
                row.customer_name || row.guest_name == true
                  ? row.customer_name || row.guest_name
                  : "-",
              label: "Customer Name"
            },
            {
              value: row =>
                row.customer_mobile || row.guest_mobile == true
                  ? row.customer_mobile || row.guest_mobile
                  : "-",
              label: "Mobile No"
            }

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: new_records
        }
      ];
      let settings = {
        fileName: `TransactionRefundReport${new Date().getTime()}`
      };
      xlsx(data, settings);
    },
    changeFilterValues(event) {
      let value = event.target.value;
      this.clearDate({ name: "fromDate" });
      this.clearDate({ name: "endDate" });
      this.onTransactionRefundsDropDownHandler({
        event: value,
        name: "filterValue"
      });
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onTransactionRefundsDropDownHandler({
                  name: "isCinema",
                  selectedItem: x
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>

<style>
table tr {
  white-space: nowrap !important;
}
.swap {
  color: var(--swap-color);
}
.pdf_heading_alignment {
  border: 1px solid black;
  margin: 20px auto;
  width: 90%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/TransactionRefundComponents/viewTransactionRefunds.vue